import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-9e6dc9e3.js';
import 'classnames';

var ElectricWindow = createSvgIcon(React__default.createElement("path", { "clip-rule": "evenodd", d: "M10.791 6a1 1 0 0 0-.684.27L3.28 12.671 6.559 18H20V6h-9.209ZM8.74 4.811A3 3 0 0 1 10.791 4h11.21v16H5.44l-.292-.476-4-6.5-.428-.695.595-.559L8.74 4.812ZM9.5 14.5l3.176-3.5-.176 2 2 .25-3 3.75.5-2-2.5-.5Zm2-7h-.414l-.293.293-4.5 4.5 1.414 1.414L11.914 9.5H17V12h-1v2h3V7.5h-7.5Z", fillRule: "evenodd" }), 'ElectricWindow');

export { ElectricWindow };
